import { toSizeInKb } from "./../ricos-content";
import { unreachable } from "./../ricos-content/ts-utils";
import { logInvariant } from "./../_shared/log-invariant";
import { upload } from "./../_shared/upload/upload";
import { FILE_UPLOAD_TYPE } from "./types";
const getFileAttributes = ({
  uploadData,
  componentData
}) => {
  const { url, id, privacy, size, ...rest } = uploadData;
  const src = url ? { url } : { id };
  const parsedSize = isNaN(parseInt(size?.toString() ?? "")) ? null : parseInt(size?.toString() ?? "");
  return {
    ...componentData,
    ...rest,
    src: { ...src, private: privacy === "private" },
    size: parsedSize,
    pdfSettings: uploadData.pdfSettings || componentData?.pdfSettings || null,
    loading: false
  };
};
const getFilePickMedia = ({
  config,
  services
}) => {
  const { handleFileSelection } = config;
  const devPickMedia = services.devService().pickMedia;
  return devPickMedia ? devPickMedia : handleFileSelection ? async () => {
    const data = await new Promise(
      (resolve) => handleFileSelection(({ data: data2 }) => resolve(data2))
    );
    return { type: "ready-media", media: data instanceof Array ? data : [data] };
  } : async ({ mimeType }) => {
    const files = await services.uploadService?.selectFiles({ accept: mimeType, multiple: false }) ?? [];
    return { type: "file", file: files, customUploadFn: config.onFileSelected };
  };
};
const handleFileUpload = async ({
  config,
  services,
  publicCommands,
  nodeId
}) => {
  const { accept = "*", multi = true, onFileSelected } = config;
  const pickMedia = getFilePickMedia({ config, services });
  const result = await pickMedia({ mimeType: accept, multiple: nodeId ? false : multi });
  switch (result.type) {
    case "ready-media": {
      const data = result.media;
      if (nodeId) {
        const componentData = publicCommands?.getBlockComponentData(nodeId);
        publicCommands?.setBlock(nodeId, FILE_UPLOAD_TYPE, {
          ...componentData,
          ...getFileAttributes({ uploadData: data[0], componentData })
        });
        return;
      }
      data.forEach((file, index) => {
        setTimeout(() => {
          publicCommands.insertBlockWithBlankLines(
            FILE_UPLOAD_TYPE,
            getFileAttributes({
              uploadData: file,
              componentData: {}
            }),
            { updateSelection: data.length === index + 1 }
          );
        });
      });
      return;
    }
    case "file": {
      const files = result.file;
      files.map(async (_file, index) => {
        const targetNodeId = nodeId ?? publicCommands.insertBlockWithBlankLines(
          FILE_UPLOAD_TYPE,
          {},
          { updateSelection: files.length === index + 1 }
        );
        const file = new File([_file], _file.name, { type: _file.type });
        const trackBi = services.uploadService.trackUploadBi(
          FILE_UPLOAD_TYPE,
          file.size,
          file.name
        );
        try {
          const { name, size } = file;
          const type = name.split(".").pop();
          publicCommands?.setBlock(targetNodeId, FILE_UPLOAD_TYPE, {
            ...publicCommands?.getBlockComponentData(targetNodeId),
            name,
            size,
            sizeInKb: toSizeInKb(size),
            type,
            loading: true,
            tempData: true,
            error: null
          });
          trackBi?.start();
          const uploadFn = result.customUploadFn || onFileSelected;
          if (!uploadFn) {
            logInvariant(Error("No upload function provided"));
            throw new Error("No upload function provided");
          }
          const uploadedFile = await upload(uploadFn, file);
          const uploadData = uploadedFile.data;
          publicCommands?.setBlock(targetNodeId, FILE_UPLOAD_TYPE, {
            ...getFileAttributes({
              uploadData,
              componentData: publicCommands?.getBlockComponentData(targetNodeId)
            }),
            error: null,
            tempData: null,
            loading: false
          });
          trackBi?.success();
        } catch (error) {
          const componentData = publicCommands?.getBlockComponentData(targetNodeId);
          publicCommands?.setBlock(targetNodeId, FILE_UPLOAD_TYPE, {
            ...componentData,
            error,
            loading: null
          });
          trackBi?.error(error);
          services.uploadService.notifyError(error);
        }
      });
      return;
    }
    case "cancel": {
      return;
    }
    default: {
      console.error(unreachable(result));
    }
  }
};
export {
  handleFileUpload
};
//# sourceMappingURL=handle-file-upload.js.map
